import { useEffect, useState } from 'react';

// Segundos desde a primeira vez que a chamada conectou. Continua contando em
// reconexões e com o modal minimizado; zera quando `reset` liga.
export default function useCallClock(connected, reset) {
  const [startedAt, setStartedAt] = useState(null);
  const [now, setNow] = useState(() => Date.now());

  useEffect(() => {
    if (reset) {
      setStartedAt(null);
      return;
    }
    if (connected && startedAt === null) {
      const time = Date.now();
      setStartedAt(time);
      setNow(time);
    }
  }, [connected, reset, startedAt]);

  useEffect(() => {
    if (startedAt === null) {
      return undefined;
    }
    const timer = setInterval(() => setNow(Date.now()), 1000);
    return () => clearInterval(timer);
  }, [startedAt]);

  if (startedAt === null) {
    return 0;
  }
  return Math.max(Math.floor((now - startedAt) / 1000), 0);
}
